import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMousewheel = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 4.498 7.408",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 1.5,
		strokeWidth: .212,
		clipRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M.15 2.287a2.1 2.1 0 0 1 4.198 0v2.834a2.1 2.1 0 0 1-4.198 0z" }),
			/* @__PURE__ */ _jsx("path", { d: "m1.681 1.8.568-.57.57.57M2.816 3.627l-.567.569-.57-.57" }),
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 2.249,
				cy: 2.732,
				rx: .429,
				ry: .588
			})
		]
	})
});
export default SvgIconMousewheel;
